import { createIcon } from './utils/createIcon.js';

export default createIcon({
  paths: [
    'M17 3h-5.08c-.276 0-.5.224-.5.5s.224.5.5.5H17c.552 0 1 .448 1 1v13c0 .552-.448 1-1 1H7c-.552 0-1-.448-1-1v-6.5c0-.276-.224-.5-.5-.5s-.5.224-.5.5V18c0 1.103.897 2 2 2h10c1.103 0 2-.897 2-2V5c0-1.103-.897-2-2-2z',
    'M2.414 3.414c-.552-.552-.552-1.448 0-2 .276-.276.638-.414 1-.414s.724.138 1 .414l.904.904-2 2-.904-.904zm8.703 4.703l.782.783-2 2-.328-.329-5.546-5.546 2-2 5.092 5.092zm2.807 4.808l-3.278-1.358 1.92-1.92 1.358 3.278zm-4.121-.707l.141.14.184.076 5.644 2.338-2.414-5.828L5.121.707C4.664.251 4.058 0 3.414 0c-.645 0-1.251.251-1.707.707S1 1.769 1 2.414s.251 1.251.707 1.707l8.096 8.097z',
  ],
  height: 20,
  width: 20,
});
